import gql from "graphql-tag";

const signUpload = gql`
  mutation signUpload {
    signUpload {
      signature
      timestamp
    }
  }
`;

export default signUpload;
